
export const categoryTypes = [
    "Learning", "Curriculum", "Mood", "StudentDocuments", "StaffDocuments",
    "IncidentType", "LeaveType", "Video", "Photo", "Nap"
]

export const currencyList = [
    { id: 1, value: "£" },
    { id: 2, value: "€" },
    { id: 3, value: "$" },
]

export const subscriptionType = [
    { key: 1, value: 1, label: "Monthly" },
    { key: 2, value: 3, label: "Quarterly" },
    { key: 3, value: 6, label: "Half-Yearly" },
    { key: 4, value: 12, label: "Yearly" },
]

export const newLetterStatus = {
    sent: "Sent",
    scheduled: "Scheduled",
    draft: "Draft",
}

export const requestStatus = {
    pending: "PENDING",
    progress: "PROGRESSED",
    closed: "CLOSED",
    approved: "APPROVED"
}

export const requestStatusData = [
    { label: 'Approved', value: requestStatus.approved },
    // { label: 'Closed', value: requestStatus.closed },
];



export const getEnquiryStatus = (status) => {
    switch (status) {
        case requestStatus.pending:
            return "#B1AB86";
        case requestStatus.approved:
            return "#6BC445";
        case requestStatus.progress:
            return "#0BA6DF"; // antd built-in green
        case requestStatus.closed:
            return "#E62727";

        default:
            return "default"; // fallback
    }
};

export const getNewsLetterStatus = (status) => {
    switch (status) {
        case newLetterStatus.sent:
            return "#6BC445"; // antd built-in green
        case newLetterStatus.draft:
            return "#FE7743";
        case newLetterStatus.scheduled:
            return "#FF9F00";
        default:
            return "default"; // fallback
    }
};

export const getCmsDataObject = {
    privacy: "Privacy Policy",
    terms: "Terms & Conditions",
    about: "About Us"
}

export const getCmsData = ["Privacy Policy", "Terms & Conditions", "About Us"]
export const getCmsTypes = ["Admin", "Staff", "Parent"]

export const dayCareDate = [
    { key: 1, label: "Start", value: "startDateFrom" },
    { key: 2, label: "Expire", value: "expiryDateFrom" },
]


export const currencyData = ['USD', 'INR', 'EUR', 'GBP', 'AED', 'CAD', 'AUD', 'CHF', 'JPY', 'NZD']

export const getTransactionStatus = (status) => {
    switch (status) {
        case 'completed':
            return "#6BC445";
        case 'failed':
            return "#FE7F2D";
        case 'expired':
            return "#BE1A1A";
        case 'pending':
            return "#FFBF00";
        default:
            return "default"; // fallback
    }
};


export const getRequestStatus = [
    { label: "Pending", value: requestStatus.pending },
    { label: "In Progress", value: requestStatus.progress },
    { label: "Closed", value: requestStatus.closed },
    { label: "Approved", value: requestStatus.approved },
]